<template>
    <div></div>
</template>

<script>
    import {message} from '../../services';
    import axios from "axios";

    export default {
        components: {},
        data() {
            console.log("data");
            return {

            }
        },
        created() {
            //console.log(this.$store.state.auth.user);
            let role = parseInt(this.$store.state.auth.user.role);
            console.log("role:"+role);
            //this.$router.push('/AdminPage');
            if (role == 43){
              this.$router.push('/SchoolHomeInfo');
            } else{
              this.$router.push('/home');
            }

/*
            switch (role) {
                case 1:
                    //debugger;
                    console.log("1");
                    this.$router.push('/TeacherPage');
                    break;
                case 2:
                    console.log("2");
                    this.$router.push('/StudentPage');
                    break;
                case 4:
                    console.log("4");
                    this.$router.push('/TeacherPage');
                    break;
                case 3:
                    console.log("3");
                    console.log("route 3");
                    this.$router.push('/AdminPage');
                    break;
            }
*/
        }
    };
</script>